import { DATASOURCE_METRIC_KEY_MAP } from '@intelligence/v3/_config/metrics';
import { publisherCheckboxList } from './common';

import type { BusinessDownloadConfig } from '../types';

// 不展示 PC/PC&Console 页新增的 stream_id 字段
const currentPublisherCheckboxList = {
  ...publisherCheckboxList,
  defaultValue: {
    ...publisherCheckboxList.defaultValue,
    region_show: undefined,
    steam_id_show: undefined,
    sensortower_tags_show: false,
  },
  options: [
    ...(publisherCheckboxList?.options?.slice(0, 3) || []),
    { label: 'dbi_sensortower_tags', value: 'sensortower_tags_show' },
  ],
};

const overlapMobileGamesConfig: BusinessDownloadConfig = {
  'overlap-mobile-games': {
    apiUrl: 'api/v1/intelligence_pc/pcTopChartCrossAppUsagesRankExcel',
    bubbleText: '',
    translate: true,
    formList: [
      {
        label: 'dbi_label_metrics',
        type: 'checkboxGroup',
        field: 'metrics',
        defaultValue: [
          DATASOURCE_METRIC_KEY_MAP.SENSORTOWER__ACTIVE_USERS,
          DATASOURCE_METRIC_KEY_MAP.SENSORTOWER__CROSS_APP_USAGE,
          DATASOURCE_METRIC_KEY_MAP.SENSORTOWER__CROSS_AFFINITY,
        ],
        options: [
          { label: 'dbi_mau', value: DATASOURCE_METRIC_KEY_MAP.SENSORTOWER__ACTIVE_USERS },
          { label: 'dbi_metric_mobile_cross_usage', value: DATASOURCE_METRIC_KEY_MAP.SENSORTOWER__CROSS_APP_USAGE },
          {
            label: 'dbi_metric_mobile_cross_affinity',
            value: DATASOURCE_METRIC_KEY_MAP.SENSORTOWER__CROSS_AFFINITY,
          },
        ],
      },
      // publisherCheckboxList,
      currentPublisherCheckboxList,
      {
        label: 'dbi_label_data_calculation',
        type: 'subForm',
        children: [
          // {
          //   label: 'dbi_label_palyform_Setting',
          //   type: 'checkboxGroup',
          //   field: 'platforms',
          //   defaultValue: ['appstore', 'googleplay'],
          //   options: [
          //     { label: 'iOS', value: 'appstore' },
          //     { label: 'Google Play', value: 'googleplay' },
          //   ],
          // },
          {
            label: 'dbi_label_time_settings',
            type: 'dateRangeMonth',
            defaultValue: ['2023-06-01', '2023-06-30'],
            field: 'dateRange',
            message: 'dbi_selected_multiple_months',
            options: [],
          },
          {
            label: 'dbi_label_country_settings',
            type: 'countrySettings',
            field: 'download_markets',
            message: 'dbi_selected_multiple_country',
            defaultValue: ['us'],
            options: [],
          },
          {
            label: 'dbi_label_ratio',
            type: 'switch',
            disabled: false,
            defaultValue: true,
            field: 'ratio_show',
            options: [],
          },
        ],
      },
    ],
  },
};

export default overlapMobileGamesConfig;
